import { Component, Input, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { OrderService } from '../../shared/services/index';
import { ActivatedRoute } from '@angular/router';
import { Order, User, ILLGenericKeys } from '../../shared/models';

@Component({
    selector: 'order-summary',
    templateUrl: './order-summary.component.html',
    styleUrls: ['./order-summary.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class OrderSummaryComponent implements OnInit, AfterViewInit {

    // Local variables to display in component, some are calculated.
    chargeableOrder = '';
    serviceTypeDesc = '';
    deliveryPrDesc = '';
    orderOwnersDesc = '';

    // Passed in by parent component,
    // will be STEP1, STEP2, or STEP3,
    // to control which rows are visible.
    @Input() whichStep = '';

    @Input() order: Order;
    workFlowOrderIdDesc: string;

    @Input() allEmployeesInCompany: User[];

    @Input() serviceCategories: ILLGenericKeys[];

    @Input() serviceTypes: ILLGenericKeys[];


    constructor(
        private activatedRoute: ActivatedRoute,
        private orderService: OrderService) {
    }

    ngOnInit() {
        this.workFlowOrderIdDesc = '';
        this.serviceTypeDesc = '';
    }

    // There were weird timing errors, I had to postpone
    // loading the order data a little bit to let everything
    // catch up.
    ngAfterViewInit() {
        setTimeout(() => {
            this.loadData();
        }, 200);
    }

    loadData() {
        if (this.order) {

            // Show Appian ID as draft if in draft mde, else read workflowOrderId
            this.workFlowOrderIdDesc = 'Draft';
            if (this.order && (this.order.orderStatus != this.orderService.ORDER_STATUS_DRAFT)) {
                // We'll, don't show "null" either
                if (!this.order.workFlowOrderId || (this.order.workFlowOrderId == 0)) {
                    this.workFlowOrderIdDesc = 'n/a';
                } else {
                    this.workFlowOrderIdDesc = '' + this.order.workFlowOrderId;
                }
            }

            if (this.order.splService) {
                this.serviceTypeDesc = this.order.splService.label;
            }

            // Delivery priority - get description from code
            this.deliveryPrDesc = this.order ? this.orderService.getDeliveryPriorityDescription(this.order.deliveryPriority) : '';

            // if there are inactive owners, concatenate them to the owner list as well.
            const inactiveOwnerList = this.orderService.GetInactiveOrderUsers(this.allEmployeesInCompany, this.order.orderUsers, this.orderService.ORDER_USER_TYPE_ORDER_OWNER);

            // Convert order's array of OrderUsers into delimited
            // first+last string from employees array
            this.orderOwnersDesc = this.orderService.getUserNamesFromOrderUsers(
                this.allEmployeesInCompany, this.order.orderUsers, this.orderService.ORDER_USER_TYPE_ORDER_OWNER);

            const inactiveOwnerNames = inactiveOwnerList
            .map(x => x.name)
                .join(', ');
            if (inactiveOwnerNames) {
                this.orderOwnersDesc = `${this.orderOwnersDesc}, ${inactiveOwnerNames}`;
          }
        }
    }
}
